<template>
  <v-card flat tile>
    <v-card-text>
      <comment-history :commentService="commentService"
                       :showDialog="isCommentsDialogOpen"
                       :readonly="readonly"
                       @close="closeCommentsDialog"
                       @commentEntered="communicateCommentEnteredToTab">
      </comment-history>
      <div class="d-flex">
        <div class="flex-grow-1">
          <v-row no-gutters>
            <v-col cols="12">
              <budget-page-header title="Market Rent" :budgetIterationId="budgetIterationId"></budget-page-header>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <market-rent-summary :budgetIterationId="budgetIterationId"></market-rent-summary>
            </v-col>
          </v-row>
          <v-row no-gutters style="border: solid 1px var(--v-resGrey-lighten3);">
            <v-col cols="12">
              <v-tabs class="market-rent-tabs" active-class="market-rent-active-tab">
                <v-tabs-slider color="resBlue darken-1"></v-tabs-slider>
                <v-tab class="market-rent-tab" :to="{ name: 'BaseRent', params: { budgetIterationId: budgetIterationId }}">BASE RENT</v-tab>
                <v-tab class="market-rent-tab" :to="{ name: 'Renovations', params: { budgetIterationId: budgetIterationId }}">RENOVATIONS</v-tab>
                <v-tab class="market-rent-tab" :to="{ name: 'Amenities', params: { budgetIterationId: budgetIterationId }}">AMENITIES</v-tab>
              </v-tabs>
            </v-col>
          </v-row>
          <keep-alive>
            <router-view :key="$route.fullPath" :readonly="readonly" :lockedByGL="lockedByGL" :commentIteration="commentIteration" @openComments="openComments" @denied-status="displayDeniedMessage"></router-view>
          </keep-alive>
        </div>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
</template>

<script>
  import BudgetPageHeader from '@/components/budgets/common/BudgetPageHeader';
  import MarketRentSummary from '@/components/budgets/worksheet/MarketRentSummary';
  import CommentHistory from '@/components/budgets/dialogs/CommentHistory.vue'
  import worksheetService from '@/services/worksheet';
  import budgetService from '@/services/budget';
  import EditBudget from '@/mixins/EditBudget.js';
  import { mapActions } from 'vuex';

  export default {
    name: 'MarketRent',
    components: {
      BudgetPageHeader,
      CommentHistory,
      MarketRentSummary
    },
    mixins: [EditBudget],
    props: {
      budgetIterationId: {
        required: true
      },
    },
    data: function () {
      return {
        tabTypes: {
          'baserent': 1,
          'renovations': 2,
          'amenities': 3
        },
        commentService: null,
        isCommentsDialogOpen: false,
        commentIteration: 0
      };
    },
    computed: {
    },
    methods: {
      ...mapActions(['changeLoading']),
      async loadBudgetStatus() {
        let settings = await budgetService.getBudgetSettings(this.budgetIterationId);
        this.reforecastLocked = settings.reforecastLocked;
        this.lockedByGL = settings.lockedByGL;
        this.status = settings && settings.status;
        this.userCanEdit = settings && settings.userCanEdit;
        this.userCanEditApproved = settings && settings.userCanEditApproved;
        this.userCanEditPublished = settings && settings.userCanEditPublished;
      },
      openComments(type) {
        var tabTypeId = this.tabTypes[type];
        if (tabTypeId) {
          this.initCommentsService(this.budgetIterationId, tabTypeId, this.readonly);
          this.openCommentsDialog();
        }
      },
      initCommentsService(budgetIterationId, tabTypeId, readonly) {       
        this.commentService = {
          getComments: () => worksheetService.getComments(budgetIterationId, tabTypeId),
          createComment: async (note, isFlag, repliesToNoteId) => {
            if (readonly) {
              this.displayDeniedMessage();
              return;
            }
            return await worksheetService.createComment(note, isFlag, repliesToNoteId, budgetIterationId, tabTypeId)
          },
          resolveComment: async (workingRowNoteId, note) => {
            if (readonly) {
              this.displayDeniedMessage();
              return;
            }
            return await worksheetService.resolveComment(workingRowNoteId, note)
          },
          editComment: async (commentId, commentText) => {
            if (readonly) {
              this.displayDeniedMessage();
              return;
            }
            await worksheetService.editComment(commentId, commentText);
          },
          deleteComment: async (commentId) => {
            if (readonly) {
              this.displayDeniedMessage();
              return;
            }
            await worksheetService.deleteComment(commentId);
          }
        }
      },
      openCommentsDialog() {
        this.isCommentsDialogOpen = true;
      },
      closeCommentsDialog() {
        this.isCommentsDialogOpen = false;
      },
      communicateCommentEnteredToTab() {
        this.commentIteration++;
      }
    },
    async mounted() {
      this.loadBudgetStatus();
    }
  }
</script>

<style lang="scss" scoped>
  .market-rent-tab {
    background-color: white;
    font-weight: 700 !important;
    color: var(--v-resGrey-darken1) !important;
  }
    .market-rent-tab.market-rent-active-tab {
      color: var(--v-resBlue-darken1) !important;
    }
</style>
